import * as PIXI from "pixi.js";
import {ButtonPulse} from "../Button";
import {Mix} from "../../Core/Reflection";
import {TransformBackup} from "../../Core/TransformBackup";
import {Container} from "../../Core/Container";

export class InstrumentButton extends Mix(ButtonPulse, TransformBackup) {

    readonly animation = this.addChild(new Container());
    readonly hitAreaPoints: number[] = [];
    private keyboardSelected = false;

    constructor() {
        super();
        this.clickSfx = undefined;
        this.downScale = 1;
        this.animation.addChild(this.visuals);
    }

    onLayout() {
        if (this.hitAreaPoints && this.hitAreaPoints.length > 0) {
            this.hitArea = new PIXI.Polygon(this.hitAreaPoints.reduce((a, t, i) => {
                if (i % 2 === 0) {
                    a.push(new PIXI.Point(t));
                } else {
                    a[a.length - 1].y = t;
                }
                return a;
            }, [] as PIXI.Point[]));
        }
    }

    onFocusActivated(): void {
        if (this.enabled && this.worldVisible && !this.getAncestor((it) => !it.interactiveChildren)) {
            this.keyboardSelected = !this.keyboardSelected;
            if (this.keyboardSelected) {
                this.onDown(this);
            } else {
                this.onUp(this);
            }
        }
    }
}